<template>
  <div>
    {{ r.label }}
    <van-radio-group v-model="r.value">
      <van-row>
        <van-col v-for="n in cols" :key="n">
          <van-radio :key="n" :name="n">
            {{ n }}
          </van-radio>
        </van-col>
      </van-row>
    </van-radio-group>
  </div>
</template>
<style scoped>
.van-radio{
  height: 1.5rem;
  line-height: 1.5rem;
  margin-bottom: 0.7rem;
  margin-right:2rem;
}
</style>
<script>
export default {
  props: {
    cols: Array,
    r: Object,
  },
  mounted() {},
  data() {
    return {
      value: null,
    };
  },
  methods: {},
};
</script>
